<template>
    <div class="user-home-page dashboard-page" v-if="displayPopup">
        <main class="main-container">
            <section class="container-head" >
                <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                        <v-flex xl12 class="tenant_tool_bar">
                            <v-toolbar style="color:indigo;" dense flat color="#EFEFEF">
                                <v-toolbar-title>Advanced Search</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn :color='depressedColor' dark medium depressed @click="clearFilters(displayPopup)" class="mr-2">clear filters</v-btn>
                                
                                <v-menu offset-y max-height='40%'>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn medium dark color="deep-purple darken-3" v-bind="attrs" v-on="on"> +More Filters </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item v-for="(item,index) in filtersList" :key="index">
                                            <v-checkbox v-model="item['enableFilter']" :label="item['value']" @click="getEnabledFiltersList">
                                            </v-checkbox>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                                <v-btn medium dark color="deep-purple darken-3" @click="getFilteredResults" class="ml-2 mr-2"> Search </v-btn>
                                <span title="Close Advanced Search"> <v-icon id="tenantCreationBtn" @click="closeAdvancedSearchPopup(displayPopup)" style="color:#4f2e88;">close</v-icon> </span>
                            </v-toolbar>
                        </v-flex>
                    </v-layout>
                </v-container>
            </section>
            <section>
                <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                        <v-flex lg3>
                            <v-text-field
                                :color='textFieldOutline'
                                outlined
                                background-color="white"
                                label="Username"
                                placeholder="Username"
                                v-model="username"
                            ></v-text-field>
                        </v-flex>
                        <v-flex lg3>
                            <v-text-field
                                :color='textFieldOutline'
                                outlined
                                background-color="white"
                                label="App Name"
                                placeholder="App Name"
                                v-model="app_name"
                            ></v-text-field>
                        </v-flex>
                        <v-flex lg3>
                            <v-text-field
                                :color='textFieldOutline'
                                background-color="white"
                                outlined
                                label="Contains Text"
                                placeholder="Contains Text"
                                v-model="search_text"
                            ></v-text-field>
                        </v-flex>
                        <v-flex lg3 class="pa-1 pt-2">
                            <dropdown :label="'Tenants List'" :textFieldOutline='textFieldOutline' :bgcolor="'white'" :valuesList="filters_list['tenants_list']" :selectedValues="tenants_selected" @selectedValuesList="tenantsSelectedList"></dropdown>
                        </v-flex>
                        <!-- <v-flex lg3>
                        </v-flex> -->
                        <span lg1 class="pb-6 pa-1" v-for="(item,index) in enabledFiltersList" :key="index" >
                            <menudropdown v-show="item['enableFilter']"  :textFieldOutline='textFieldOutline' :label="item['value']" :bgcolor="depressedColor" :valuesList="item['emittedValuesList'].length > 0 ? item['emittedValuesList'] : filters_list[item['key']]" :selectedValues="item['emittedValuesList']" @selectedValuesList="(n) => item['emittedValuesList'] = n"></menudropdown>
                        </span>
                    </v-layout>
                </v-container>
            </section>
            <div class="advancedSearch__wrapper" id="advancedSearch">
                <div class="advancedSearch__main-container">
                    <div class="advancedSearch__data-container">
                        <div class="advancedSearch__header-container">
                            <v-card outlined tile class="advancedSearch__total-findings-container tabHeader pa-4">
                                <div class="advancedSearch__sub-header-container" v-for="(eachHeader,index) in dataTableHeaders" :key="index">
                                    <span>{{eachHeader['value']}}</span>
                                </div>
                            </v-card>
                        </div>
                    </div>
                    <div class="advancedSearch__tablebody-container" id="advancedSearchTableBody" style="height:126px;">
                        <div class="advancedSearch__body-container" v-if="(searchResults.length > 0)">
                            <div class="advancedSearch__header-container" v-for="(eachResult,index1) in searchResults" :key="index1">
                                <v-card outlined tile :class="eachResult['tenant_disabled'] ? 'disabled advancedSearch__total-findings-container pa-4' : 'advancedSearch__total-findings-container pa-4'">
                                    <div class="advancedSearch__sub-header-container" v-for="(eachHeader,index) in dataTableHeaders" :key="index">
                                        <span v-if="(eachResult[eachHeader['key']] && eachHeader['key'] != 'app_role')" :class="['tenant_name','username','app_name'].includes(eachHeader['key']) ? 'pointer' : 'nopointer'" @click="changePage(eachHeader['key'],eachResult['tenant_schema'])" :title="eachResult[eachHeader['key']] || '-'">{{eachResult[eachHeader['key']]}}</span>
                                        <span v-else-if="(eachResult[eachHeader['key']] && eachHeader['key'] == 'app_role')" :class="['tenant_name','username','app_name'].includes(eachHeader['key']) ? 'pointer' : 'nopointer'" @click="changePage(eachHeader['key'],eachResult['tenant_schema'])" :title="eachResult[eachHeader['key']] || '-'" >{{eachResult[eachHeader['key']].join()}}</span>
                                        <span v-else :class="['tenant_name','username','app_name'].includes(eachHeader['key']) ? 'pointer' : ''" @click="changePage(eachHeader['key'],eachResult['tenant_schema'])" :title="eachResult[eachHeader['key']] || '-'">-</span>
                                    </div>
                                </v-card>
                            </div>
                            
                        </div>
                        <div class="advancedSearch__body-container" v-else>
                            <div class="advancedSearch__header-container">
                                <v-card outlined tile class="advancedSearch__total-findings-container pa-4 justify-center" style="text-align: center;">
                                        <span v-if="enableAdvancedSearch">No Data Found!!</span>
                                        <span v-else>Right now there is no filter enabled!!</span>
                                </v-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Snackbar
                v-if="showSnackbar"
                :snackbarColor="snackbarColor"
                :snackbarMessage="snackbarMessage"
                @close="closeSnackbar()"
            >
            </Snackbar>
        </main>
    </div>
</template>
<script>
import Vue from 'vue';
import {hideLoadIcon,showLoadIcon} from '../../../common/assets/utils/load.js';
import dropdown from '../subcomponents/dropdowns.vue';
import menudropdown from '../subcomponents/menuDropdown.vue';
import Snackbar from "../../../common/components/snackbar"
import { mapState, mapGetters, mapActions } from 'vuex';


export default {
    name: 'AdvancedSearch',
    props: {
        enablePopup: {
            type: Boolean,
            defaults: false
        },
        
    },
    components:{
        menudropdown,
        dropdown,
        Snackbar
    },
    data () {
        return {
            depressedColor: "#736B63",
            textFieldOutline: "#4B00B2",
            displayPopup: false,
            toggleSelect: false,
            username : [],
            app_name: [],
            search_text:[],
            showSnackbar: false,
            snackbarColor: null,
            snackbarMessage: null,
            tenants_selected : [],
            enabledFiltersList: [],
            dataTableHeaders:[
                                {key:'tenant_name',value:'Tenant Name'},
                                {key:'tenant_server',value:'Tenant Server'},
                                {key:'username',value:'Username'},
                                {key:'app_name',value:'App Name'},
                                {key:'app_type',value:'App Type'},
                                {key:'app_role',value:'App Roles'},
                             ],
        }
    },
    watch: {
        filtersList(){
            this.enabledFiltersList = this.filtersList.filter(item => item['enableFilter'] == true ? true : false)
        },
        enablePopup(){
            this.displayPopup = this.enablePopup
            if (this.displayPopup == true) this.filterDetails(); 
        }
    },
    created(){
        
    },
    computed:{
        ...mapState({
            filtersList: state => state.advancedSearchDetails.advancedSearchFilters,
            filters_list: state => state.advancedSearchDetails.advancedSearchFilterValues,
            searchResults: state => state.advancedSearchDetails.searchResults,
            final_filters: state => state.advancedSearchDetails.final_filters,
            enableAdvancedSearch: state => state.advancedSearchDetails.enableAdvancedSearch
        }),
    },
    mounted() {
        if(this.final_filters.username) this.username = this.final_filters.username[0]
        if(this.final_filters.provisioned_services_name) this.app_name = this.final_filters.provisioned_services_name[0]
        if(this.final_filters.search_text) this.search_text = this.final_filters.search_text
        if(this.final_filters.tenant_name) this.tenants_selected = this.final_filters.tenant_name

    },
    methods: {
        ...mapActions({
            filterDetails: 'advancedSearchDetails/getFiltersList'
        }),
        getEnabledFiltersList(){
            this.enabledFiltersList = this.filtersList.filter(item => item['enableFilter'] == true ? true : false)
        },
        changePage(key,schema){
            var redirectPage = {'tenant_name':'tenants','username':'users','app_name':'apps'}
            if(['tenant_name','username','app_name'].includes(key))
            {
                if(redirectPage[key]=='tenants'){
                    if(this.$parent.page=='tenants')  this.$emit('togglepopup', false)
                    else this.$router.push(`/${redirectPage[key]}`);
                }
                else{
                    if(this.$parent.page==redirectPage[key]) {
                       if(this.$parent.tenantInfo.schema_name==schema) this.$emit('togglepopup', false)
                       else {
                           this.$parent.initializeData({schemaName: schema});
                           if(this.$store.state.advancedSearchDetails.tenantSeperatedDetails[this.$parent.tenantInfo['schema_name']])this.$emit('togglepopup', false)
                        }
                    }
                    else {
                        this.$parent.initializeData({schemaName: schema, route: redirectPage[key]});
                    }
                }
                
            }
            else{
                return
            }
        },
        modifyText(text)
        {
            if(text && text.length > 18){
                return text.substr(0,18)+'...'
            }
            else{
                return text
            }
        },
        closeAdvancedSearchPopup(value){
            if(this.$parent.page!=='tenants' && this.$store.state.advancedSearchDetails.enableAdvancedSearch==true && !this.$store.state.advancedSearchDetails.tenantSeperatedDetails[this.$parent.tenantInfo['schema_name']]){
                this.$router.push(`/tenants`);
            }
            // var self = this
            this.displayPopup = !value;
            this.$emit('togglepopup', !value)
        },
        tenantsSelectedList(value){
            this.tenants_selected = value
        },
        checkBox(index,key){
            if(this.displayFilters.includes(index)) this.displayFilters = this.displayFilters.filter(item => item !== index)
            else this.displayFilters.push(index)
        },
        clearFilters(){
            var self = this
            self.username = ''
            self.app_name = ''
            self.search_text = ''
            self.tenants_selected = []
            self.enabledFiltersList = []
            this.filterDetails()
            this.$store.state.advancedSearchDetails.searchedFilters = []
            this.$store.state.advancedSearchDetails.searchResults = []
            this.$store.state.advancedSearchDetails.final_filters = {}
            this.$store.state.advancedSearchDetails.enableAdvancedSearch = false
            this.$store.state.advancedSearchDetails.tenantSeperatedDetails = {}
        },
        getFilteredResults(){
            var self = this
            var formData = new FormData();
            let final_filters_list = {}
            if(self.username.length > 0) final_filters_list['username'] = [self.username]
            if(self.app_name.length > 0) final_filters_list['provisioned_services_name'] = [self.app_name]
            if(self.search_text.length > 0) final_filters_list['search_text'] = self.search_text
            if(self.tenants_selected.length > 0) final_filters_list['tenant_name']=self.tenants_selected
            let selectedFiltersList = self.enabledFiltersList.filter(i => i['emittedValuesList'].length > 0 ?  i['enableFilter'] : false)
            for(let value in selectedFiltersList){
                let key = selectedFiltersList[value]['key'] 
                let vals = selectedFiltersList[value]['emittedValuesList'].filter(item => item.enable ? true : false)
                if(vals.length>0){
                    final_filters_list[key]=[]
                    for(let val in vals){
                        final_filters_list[key].push(vals[val]['key'])
                    }
                }
            }
            console.log(final_filters_list)
            if(Object.keys(final_filters_list).length < 1) 
            {
                self.displaySnackbar('error-banner',"Select Atleast one Filter to process");
                return
            }
            formData.append('json',JSON.stringify(final_filters_list))
            showLoadIcon();
            this.$loading(true);
            Vue.http.post("/fetch_advancedsearch_results/",formData)
            .then((res) =>{
                try{
                    this.$store.state.advancedSearchDetails.final_filters = final_filters_list
                    this.$store.state.advancedSearchDetails.searchedFilters = self.filtersList
                    this.$store.state.advancedSearchDetails.searchResults = res['data']['filtered_data']
                    this.$store.state.advancedSearchDetails.enableAdvancedSearch = true
                    let arr={}
                    let searchResults = res['data']['filtered_data']
                    for(let val in searchResults){
                        if(!arr[searchResults[val]['tenant_schema']]){
                            arr[searchResults[val]['tenant_schema']] = {}
                            arr[searchResults[val]['tenant_schema']]['app_id'] = []
                            arr[searchResults[val]['tenant_schema']]['user_id'] = []
                        }
                        if(searchResults[val]['app_id']){
                            if(!arr[searchResults[val]['tenant_schema']]['app_id'].includes(searchResults[val]['app_id'])){
                                arr[searchResults[val]['tenant_schema']]['app_id'].push(searchResults[val]['app_id'])
                            }
                        } 
                        if(searchResults[val]['user_id']){
                            if(!arr[searchResults[val]['tenant_schema']]['user_id'].includes(searchResults[val]['user_id'])){
                                arr[searchResults[val]['tenant_schema']]['user_id'].push(searchResults[val]['user_id'])
                            }
                        }                    
                    }
                    console.log(arr)
                    this.$store.state.advancedSearchDetails.tenantSeperatedDetails = arr
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',"Unable to Process your request, please try again after some time.");
            })
        },
        displaySnackbar(color,message){
            var self = this;
            self.showSnackbar = false;
            setTimeout(function(){
                self.showSnackbar = true;
            },100)
            self.snackbarColor = color;
            self.snackbarMessage = message;
        },
        closeSnackbar(){
            var self = this;
            self.showSnackbar = false;
            self.snackbarColor = null;
            self.snackbarMessage = null;
        },
    }
}
</script>
<style lang="scss">
.dashboard-page{
    // font-family: 'TitilliumWeb-Regular';
}
.advanced_search_logo{
    font-size: 3rem !important;
    color: #5D1D99 !important;
}
.v-select__selections {
    min-height: unset !important;
}
.red{
    color:red
}
.title{
    text-align: center;
    font-weight: bold;
}

.center{
    text-align: center;
}
.tenant-name-text,.user-name-text,.app-name-text{
    color:blue;
}
.pointer:hover{
    cursor: pointer;
    color: black;
}
.nopointer{
    cursor: default;
}
.table_max_height{
    min-height: 32rem;
}
.table_min_height{
    min-height: 28rem;
}
.scrollable_container{
    overflow-x:scroll
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
    padding-top: 0;
    margin-bottom: unset !important;
    display: none; 
}

.tabHeader{
    font-weight: bold;
    font-size: 1rem;
}
.advancedSearch__wrapper {
    // font-family: 'TitilliumWeb-Regular';
    .advancedSearch__main-container {
        width: 100%;
        // // height: 800px;
        // margin: 16px;
        margin-top: 1px;
        
        .advancedSearch__header-container {
            display: flex;
        }
        .advancedSearch__total-assets-container,
        .advancedSearch__total-findings-container {
            // width: 27.6%;
            width: 100%;
            display: flex;
            align-items: center;
            // border: 1px solid;
        }
        .advancedSearch__sub-header-container {
            
            width: 16.6%;
            flex-shrink: 0;
            // border: 1px solid;
            .header-text {
                cursor: pointer;
            }
            .header-icon {
                font-size: 14px;
            }
        }
        
        .advancedSearch__data-container {
            padding-right: 3px;
        }
        
        .advancedSearch__tablebody-container {
            min-height: 450px;
            overflow-y: scroll;
            overflow-x: hidden;
        }
        
    }
    @media screen and (max-width: 1635px) {
        
        .advancedSearch__main-container {
            // font-size: 0.8rem;
            .advancedSearch__total-findings-container {
                width: 99.5%;
            }
        }
    }
}

</style>